/// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  id: string,
  label?: string,
  options: Array<{ label: string, value: any }>,
  prelabel?: string,
  maj?: boolean,
  title?: boolean,
  radio?: boolean,
  select?: boolean,
  navBar?: boolean,
  noBorder?: boolean,
  isDark?: boolean,
  big?: boolean,
  marge?: boolean,
  packed?: boolean,
  labelIcon?: string,
  isShadow?: boolean,
  isActive?: boolean,
  isPreLabelThin?: boolean,
  inputChanged?: (value: string) => void,
  dropdownStyle?: Object,
  titleUpperCase?: boolean
};

type State = {
  label: string,
  isOpen: boolean
};

class DropdownRadioInput extends PureComponent<Props, State> {
  props: Props;
  wrapperRef: any;

  static defaultProps = {
    id: 'dropdownradioinput123',
    options: [
      {
        value: 'option1',
        label: 'option1'
      }
    ],
    isActive: true,
    isPreLabelThin: true
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      label: props.options[0] ? props.options[0]['label'] : '',
      isOpen: false
    };
  }

  static getDerivedStateFromProps(props: Props, state: State) {
    const { label: propsLabel } = props;
    const { label } = state;

    if (propsLabel && label !== propsLabel) {
      return { label: propsLabel };
    }

    return null;
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  render() {
    const { isOpen, label } = this.state;
    const {
      isActive,
      marge,
      radio,
      navBar,
      noBorder,
      select,
      big,
      packed,
      isDark,
      maj,
      title,
      labelIcon,
      isShadow,
      isPreLabelThin,
      dropdownStyle,
      prelabel,
      titleUpperCase,
      options,
    } = this.props;

    const classNames = dynamicClassName('dropdown');

    isOpen && classNames.add('is-open');
    marge && classNames.add('mb-3');
    radio && classNames.add('dropdown--radio');
    navBar && classNames.add('dropdown--navbar');
    noBorder && classNames.add('dropdown--noBorder');
    select && classNames.add('dropdown--select');
    big && classNames.add('dropdown--big');
    packed && classNames.add('mt-2 mt-md-0');
    isDark && classNames.add('is-dark');

    const classNamesDropdownHead = dynamicClassName('dropdown__head');

    maj && classNamesDropdownHead.add('ft-up');
    title && classNamesDropdownHead.add('ft-h6');

    const classNamesLabelIcon = dynamicClassName('icon is-inline');
    labelIcon && classNamesLabelIcon.add(labelIcon);

    const classNamesDropdownList = dynamicClassName('dropdown__list');
    isShadow && classNames.add('shadow-3');

    const classNamesPreLabel = dynamicClassName('dropdown__prelabel');
    isPreLabelThin && classNamesPreLabel.add('ft-500');

    if (isActive) {
      return (
        <div className={classNames.build()} ref={this.setWrapperRef} style={dropdownStyle}>
          <span
            role="button"
            tabIndex="0"
            className={classNamesDropdownHead.build()}
            onClick={this.handleClickDropDown}
          >
            {labelIcon && <i className={classNamesLabelIcon.build()} />}
            {prelabel && <span className={classNamesPreLabel.build()}>{prelabel}</span>}
            <span className="dropdown__label">
              {titleUpperCase ? label.toUpperCase() : label}
            </span>
          </span>
          <div className={classNamesDropdownList.build()}>
            <span
              role="button"
              tabIndex="0"
              className={classNamesDropdownHead.build()}
              onClick={this.handleClickDropDown}
            >
              {labelIcon && <i className={classNamesLabelIcon.build()} />}
              {prelabel && <span className={classNamesPreLabel.build()}>{prelabel}</span>}
              <span className="dropdown__label">
                {titleUpperCase ? label.toUpperCase() : label}
              </span>
            </span>
            <div className="dropdown__wrapper">{this.renderOptions(options)}</div>
          </div>
        </div>
      );
    }

    return (
      <div className={classNames.build()} ref={this.setWrapperRef} style={{ opacity: 0.2 }}>
        <span className={classNamesDropdownHead.build()} style={{ cursor: 'initial' }}>
          {labelIcon && <i className={classNamesLabelIcon.build()} />}
          {prelabel && <span className="dropdown__prelabel ft-500">{prelabel}</span>}
        </span>
      </div>
    );
  }

  renderOptions = (options: any) => {
    const { label } = this.state;
    const { id } = this.props;

    return options.map((option, index) => (
      <div className="radio" key={index}>
        <input type="radio" id={id + index} defaultChecked={label === option.label} />
        <label htmlFor={id + index} onClick={this.handleChecked.bind(this, option.value, option.label)}>
          {option.label}
        </label>
      </div>
    ));
  };

  handleClickDropDown = (e: MouseEvent) => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  handleChecked = (value: string, label: string) => {
    const { inputChanged } = this.props;

    if (inputChanged) inputChanged(value);

    this.setState({
      label,
      isOpen: false
    });
  };

  setWrapperRef = (node: any) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event: MouseEvent) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };
}

export default DropdownRadioInput;
